module.exports = __webpack_public_path__ + "media/assets/img/flags/es-1b4684a24835b94ae1550ab478916e78.png";